// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__B9lcM","title":"InfoRow_title__2dOK5"};